import {Component, OnInit} from '@angular/core';
import {ComponentHelper, WizardPageBaseComponent} from '@utils-lib';
import {
    AbweichenderOrtGeschaeftsleitungAngaben,
    AppNameEnum
} from '@nachdigal';
import {ActivatedRoute} from '@angular/router';
import {isEmpty} from 'lodash';

@Component({
    selector: 'common-ui-lib-abweichender-ort-geschaeftsleitung-angaben',
    templateUrl: './abweichender-ort-geschaeftsleitung-angaben.component.html'
})
export class AbweichenderOrtGeschaeftsleitungAngabenComponent extends WizardPageBaseComponent<AbweichenderOrtGeschaeftsleitungAngaben>
    implements OnInit {

    static nutzdatenPath = 'abweichenderOrtGeschaeftsleitungAngaben';
    static route = 'abweichender-ort-geschaeftsleitung-angaben';

    public erfassen: boolean;
    public kommunikationsmittelSichtbar = false;
    public entsprichtWohnanschriftLabel = '';
    public appEnum = ComponentHelper.getAppEnum(this.activatedRoute.snapshot);

    constructor(protected readonly activatedRoute: ActivatedRoute) {
        super(activatedRoute);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        if (isEmpty(this.data)) {
            this.data = {
                entsprichtWohnanschrift: {entsprichtWohnanschrift: false},
                inlandsadresse: null,
                auslandsadresse: null,
                kommunikationsmittel: null
            };
        }
        if (isEmpty(this.data.entsprichtWohnanschrift)) {
            this.data.entsprichtWohnanschrift = {entsprichtWohnanschrift: false};
        }
        if (this.appEnum === AppNameEnum.FragebogenEUn) {
            this.kommunikationsmittelSichtbar = true;
            this.convertToSingleInput();
            this.entsprichtWohnanschriftLabel = 'COMMON_UI.FRAGEBOGEN.ABWEICHENDERORTGESCHAEFTSLEITUNG.ENTSPRICHTWOHNANSCHRIFT';
            this.erfassen = !!(this.data.inlandsadresse || this.data.auslandsadresse ||
                this.data.kommunikationsmittel || this.data.entsprichtWohnanschrift?.entsprichtWohnanschrift);
        } else {
            delete this.data.kommunikationsmittel;
            this.erfassen = !!(this.data.inlandsadresse || this.data.auslandsadresse);
        }
    }

    public onAbweichenderOrtPicked(mappedOrt: AbweichenderOrtGeschaeftsleitungAngaben): void {
        this.erfassen = true;
        this.data.inlandsadresse = mappedOrt.inlandsadresse;
        this.data.auslandsadresse = mappedOrt.auslandsadresse;
        if (this.kommunikationsmittelSichtbar) {
            this.data.kommunikationsmittel = mappedOrt.kommunikationsmittel;
            this.convertToSingleInput();
        }
    }

    public onErfassenChanged(): void {
      if (this.data?.entsprichtWohnanschrift === undefined) {
        this.data.entsprichtWohnanschrift = {};
      }

      this.data.entsprichtWohnanschrift.entsprichtWohnanschrift = !this.erfassen;

      if (!this.erfassen) {
          this.data.inlandsadresse = null;
          this.data.auslandsadresse = null;
          this.data.kommunikationsmittel = null;
          this.data.entsprichtWohnanschrift.entsprichtWohnanschrift = false;
      }
    }

    protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
        return new Map<string, unknown | Array<unknown>>([
            ['inlandsadresse', this.stammdaten?.unternehmen?.abweichenderOrtGeschaeftsleitung?.inlandsadresse],
            ['auslandsadresse', this.stammdaten?.unternehmen?.abweichenderOrtGeschaeftsleitung?.auslandsadresse],
            ['kommunikationsmittel', this.stammdaten?.unternehmen?.abweichenderOrtGeschaeftsleitung?.kommunikationsmittel]
        ]);
    }

    private convertToSingleInput(): void {
        if (this.data.kommunikationsmittel?.internet && this.data.kommunikationsmittel?.internet instanceof Array) {
            this.data.kommunikationsmittel.internet = this.data.kommunikationsmittel?.internet[0];
        }
    }
}
